module.exports = __webpack_public_path__ + "img/send.46bb3a06.png";